module.exports = __webpack_public_path__ + "img/エルピス.bce5ba15.png";